import React from 'react';
import NumberFormat from 'react-number-format';
import MUIDataTable from "mui-datatables";


const columns = [
    { name: "Tipo Producto", options: { filter: true }},
    { name: "Descripcion",options: { filter: true }},
    { name: "Cantidad", options: { filter: false }},
    { name: "Subtotal", options: { filter: false,
                                  customBodyRender: value => <NumberFormat 
                                    value={value}
                                    displayType={'text'}
                                    thousandSeparator={'.'}
                                    decimalSeparator={','}
                                    prefix="$"
                                />}}
    ]

const options =   {
    filterType: null,
    rowsPerPage: 5,
    selectableRows: false,
    downloadOptions: {
        filename: 'Detalle Orden de compra Cliente.csv',
        separator: ','
    },
    textLabels: {
        body: {
            noMatch: "No hay ordenes de compra",
            toolTip: "Sort",
        },
    },
    pagination: {
        next: "Siguiente pag",
        previous: "Anterior",
        rowsPerPage: "Filas por pagina:",
        displayRows: "de",
    },
    toolbar: {
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
    },
}


export const PoItems = (data) => {
    return (
        <MUIDataTable
            data={data.data}
            columns={columns}
            options={options}
            />
    )
}



// WEBPACK FOOTER //
// ./src/components/Customer/po_items.js